var map = {
	"./SARJ/de.json": 990,
	"./SARJ/en.json": 718,
	"./SARJ/es copy.json": 366,
	"./SARJ/es.json": 749,
	"./SARJ/fr.json": 277,
	"./SARJ/tr.json": 955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 135;